<div class="contentGrid input-grid-gaps w-full">
    <app-work-detail-select-service
        (selectedService)="form.patchValue({ serviceId: $event })"
        [preselected]="form.value.serviceId || this.store.globalGlobalStore.loggedUserStore.selectedServiceId()"
        [workType]="WorkTypeEnum.MASS_WORK"
        [allowedTypes]="[ServiceTypeEnum.SOCIAL]"
    ></app-work-detail-select-service>

    <app-input-user-multiselect
        [form]="form"
        [label]="iwPrefix + 'fields.users'"
        [serviceId]="serviceIdChange()"
        [employment]="[EmploymentParentGroupEnum.DIRECT_CARE, EmploymentParentGroupEnum.SUPPORTIVE_CARE]"
        id="users"
    ></app-input-user-multiselect>

    <app-date-input
        [prefix]="iwPrefix"
        [form]="form"
        id="dateFrom"
        [showTime]="true"
    ></app-date-input>

    <app-date-input
        [prefix]="iwPrefix"
        [form]="form"
        id="dateTo"
        [showTime]="true"
    ></app-date-input>

    <app-number-input
        #applicationsComponent
        id="applications"
        [prefix]="iwPrefix"
        (selectedValueChange)="setDuration($event)"
    ></app-number-input>

    <app-select-person
        [multiple]="true"
        [form]="form"
        [serviceId]="form.value.serviceId || 0"
        [label]="prefix + 'fields.personIds'"
        id="personIds"
    ></app-select-person>

    <app-work-participants-select
        [form]="form"
        id="participantIds"
        [label]="prefix + 'fields.participantIds'"
        [serviceId]="serviceIdChange()"
        [folders]="participantFolders()"
        [atDate]="dateFromChange()"
        [autoSelectAll]="true"
    ></app-work-participants-select>

    <app-select-input
        [prefix]="iwPrefix"
        [form]="form"
        [staticOptions]="allowedForms()"
        id="form"
    ></app-select-input>

    <app-select-input
        [prefix]="prefix"
        [form]="form"
        [staticOptions]="store.presenceOptions()"
        id="presence"
    ></app-select-input>

    <app-card class="fr-full" [title]="'service.offer.labelMulti'">
        <ng-template #content>
            <div class="flex-column gap pt-2">
                <app-work-credit-group
                    #creditGroup
                    [serviceId]="serviceIdChange()"
                    [folderIds]="folderIds()"
                    [date]="dateFromChange()"
                />
                <app-social-service-select-offer
                    [form]="form"
                    [serviceId]="form.value.serviceId"
                    id="offers"
                    (selectedOffers)="setOffers($event)"
                    [defaultUsers]="form.value.users"
                    [totalApplications]="form.value.duration || null"
                    [enableNoRecordOffers]="false"
                ></app-social-service-select-offer>

                <app-social-service-select-offer-table
                    #offerTableComponent
                    [serviceId]="form.value.serviceId"
                    [offers]="form.value.subOffers"
                    [dateFrom]="dateFromChange()"
                    [showFolders]="true"
                    [creditOffers]="creditGroup.creditOffers()"
                    [defaultPresence]="form.value.presence"
                    [offerSelectOptions]="selectOfferComponent()?.offerOptions()"
                    [showDetail]="true"
                    tableKey="socialServiceSelectOfferMassWork"
                    (updatedValues)="creditGroup.refreshCreditOffers(form.controls.subOffers.value)"
                ></app-social-service-select-offer-table>
            </div>
        </ng-template>
    </app-card>

    <app-card class="fr-3 appCard_full">
        <ng-template #header>
            <div class="flex justify-content-between align-items-center gap-small small-buttons">
                <div class="textSubheader font-bold flex-1">
                    {{ prefix + 'fields.note' | translate }}
                </div>
                <div class="flex align-items-center gap-2">
                    @if (hasMultipleOffers()) {
                        <app-multi-select-input
                            style="min-width: 15rem;"
                            [form]="form"
                            id="copyToOfferIds"
                            [prefix]="prefix"
                            [maxSelectedLabels]="1"
                            [staticOptions]="copyOfferOptions()"
                            [showClear]="true"
                        ></app-multi-select-input>
                    }
                    <app-button
                        icon="pi-copy"
                        [label]="prefix + 'message.copyNoteToOffers'"
                        (clickEvent)="copyNoteToSubOffers()"
                    ></app-button>
                </div>
            </div>
        </ng-template>

        <ng-template #content>
            <div class="flex-column gap pt-2">
                <app-tags-input
                    #tagsInputComponent
                    [form]="form"
                    id="tags"
                    [prefix]="prefix"
                    [suggestions]="store.data.searchWorkOfferTags()"
                    (queryEvent)="queryTags($event)"
                    [showClear]="true"
                ></app-tags-input>

                <app-service-pattern-wysiwyg
                    [form]="form"
                    [serviceId]="form.value.serviceId"
                    [height]="450"
                    [showLabel]="false"
                    [placeholder]="prefix + 'fields.note'"
                    [showHelpText]="true"
                    [helpText]="prefix + 'fields.noteHelp'"
                    id="note"
                    editorKey="WorkMassWork"
                    [usage]="ServicePatternStructureUsageEnum.INDIVIDUAL_WORK_RECORD"
                    (addedPattern)="formAddText(form, 'note', $event.content)"
                ></app-service-pattern-wysiwyg>
            </div>
        </ng-template>
    </app-card>

    <div class="flex-column gap fr-2 appCard_full">
        <app-file-upload-box [multiple]="true"></app-file-upload-box>
        <app-work-individual-work-operational-report-widget
            [serviceId]="form.value.serviceId"
        ></app-work-individual-work-operational-report-widget>
    </div>

    <app-action-buttons
        class="fr-full"
        (primaryClickEvent)="save()"
        [primaryButtonLoading]="store.loadingAny()"
        [primaryButtonVisibility]="canSave()"
        [primaryButtonDisability]="creditGroupComponent()?.insufficientBalance() || false"
        (secondaryClickEvent)="close()"
    ></app-action-buttons>
</div>
